/**
 * useEnv — environment info for use inside React components.
 *
 * Hostname is stable for the lifetime of a page load, so no state/effect is needed.
 *
 * Usage examples:
 *
 * // const { isNonProd, isLive, isDevelopment, env } = useEnv();
 * // return (
 * //   <>
 * //     {isNonProd && <button>Experimental action (local + dev only)</button>}
 * //     {isLive && <span>Live banner</span>}
 * //   </>
 * // );
 *
 * // For declarative show/hide, prefer <EnvOnly> (components/UI/EnvOnly).
 * // For picking a value/route per environment, use pickByEnv from utils/environment.
 */
import { getAppEnvironment } from "utils/environment";

export const useEnv = () => {
  const env = getAppEnvironment();
  return {
    env,
    isLocal: env === "local",
    isDevelopment: env === "development",
    isLive: env === "live",
    isNonProd: env !== "live",
  };
};
